import { BasicUser } from './basicUser.model';
import { BaseEntity } from '../../xform-compat';

export class Person implements BaseEntity {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  title: string;
  user: BasicUser;
  active?: boolean;

  constructor(person: any = {}) {
    this.id = person.id || null;
    this.firstName = person.firstName || null;
    this.lastName = person.lastName || null;
    this.fullName = person.fullName || null;
    this.title = person.title || null;
    this.user = person.user || null;
    this.active = person.active || null;
  }
}

export class CreatePerson {
  firstName: string;
  lastName: string;
  title: string;
  userId: number;

  constructor(person?: Person) {
    this.firstName = person ? person.firstName : null;
    this.lastName = person ? person.lastName : null;
    this.title = person ? person.title : null;
    this.userId = person && person.user ? person.user.id : null;
  }
}
